(() => {
  const init = () => {
    const root = document.getElementById('candy-pop-page');
    const config = document.getElementById('candy-pop-order-text');
    if (!root || !config || root.dataset.basketReady) return;
    const text = JSON.parse(config.textContent);
    const cards = Array.from(root.querySelectorAll('article')).filter(card => card.querySelectorAll('.candy-pop-cup-order').length === 2);
    if (!cards.length) return;
    root.dataset.basketReady = 'true';
    root.querySelectorAll('.candy-pop-drink-photo img').forEach(image => { image.loading = 'eager'; });
    const basket = new Map();
    const shortcut = document.createElement('a');
    shortcut.id = 'candy-pop-view-basket';
    shortcut.href = '#candy-pop-basket';
    shortcut.style.cssText = 'position:sticky;top:8px;z-index:2;display:block;padding:12px 16px;margin:16px 0;border-radius:30px;background:#61149c;color:#fff;text-decoration:none;text-align:center;min-height:44px;line-height:1.5';
    cards[0].parentElement.before(shortcut);
    const format = (key, values = {}) => Object.entries(values).reduce((result, [name, value]) => result.replaceAll('{' + name + '}', String(value)), text[key]);
    const controlStyle = 'width:100%;font-size:16px;min-height:44px;padding:10px 12px;border:1px solid #61149c;border-radius:10px;background:#fff;color:#25132c;font:inherit;font-size:16px';
    const makeQuantity = (id, name, value = 1) => {
      const select = document.createElement('select');
      select.id = id;
      select.setAttribute('aria-label', name);
      select.style.cssText = controlStyle;
      for (let n = 1; n <= 20; n++) {
        const option = document.createElement('option');
        option.value = String(n);
        option.textContent = String(n);
        option.selected = n === value;
        select.append(option);
      }
      return select;
    };
    const section = document.createElement('section');
    section.id = 'candy-pop-basket';
    section.setAttribute('aria-labelledby', 'candy-pop-basket-title');
    section.style.cssText = 'margin:28px 0;padding:20px;border:2px solid #61149c;border-radius:16px;background:#fff;color:#25132c';
    shortcut.addEventListener('click', event => {
      event.preventDefault();
      section.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
    const heading = document.createElement('h2');
    heading.id = 'candy-pop-basket-title';
    heading.textContent = text.basket_title;
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.style.cssText = 'margin:12px 0;line-height:1.5';
    const list = document.createElement('div');
    list.className = 'candy-pop-basket-lines';
    const total = document.createElement('p');
    total.setAttribute('aria-live', 'polite');
    total.style.cssText = 'font-weight:700;margin:16px 0';
    const methodLabel = document.createElement('label');
    methodLabel.htmlFor = 'candy-pop-basket-method';
    methodLabel.textContent = text.order_method;
    const method = document.createElement('select');
    method.id = methodLabel.htmlFor;
    method.style.cssText = controlStyle;
    for (const value of ['delivery', 'pickup']) {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = text[value];
      method.append(option);
    }
    const prompt = document.createElement('p');
    prompt.setAttribute('aria-live', 'polite');
    prompt.style.cssText = 'line-height:1.5;margin:12px 0';
    const note = document.createElement('p');
    note.textContent = text.price_note;
    note.style.cssText = 'line-height:1.5;font-size:14px';
    const send = document.createElement('a');
    send.id = 'candy-pop-send-order';
    send.textContent = text.send_order;
    send.style.cssText = 'display:block;text-align:center;min-height:44px;padding:12px 16px;border-radius:30px;background:#61149c;color:#fff;text-decoration:none;line-height:1.5;margin:16px 0';
    const directions = document.createElement('a');
    directions.href = 'https://maps.app.goo.gl/Cp5thsDNSK7NTJe1A';
    directions.textContent = text.directions;
    directions.style.cssText = 'display:inline-flex;align-items:center;min-height:44px;text-decoration:underline';
    section.append(heading, status, list, total, methodLabel, method, prompt, note, send, directions);
    cards[cards.length - 1].parentElement.after(section);
    const drinkCount = id => Array.from(basket.values()).filter(line => line.id === id).reduce((sum, line) => sum + line.quantity, 0);
    const updateMessage = () => {
      const amount = Array.from(basket.values()).reduce((sum, line) => sum + line.quantity * 15, 0);
      total.textContent = format('order_total', { amount });
      const count = Array.from(basket.values()).reduce((sum, line) => sum + line.quantity, 0);
      shortcut.textContent = format('view_basket', { count, amount });
      prompt.textContent = text[method.value + '_prompt'];
      if (!basket.size) {
        send.removeAttribute('href');
        send.setAttribute('aria-disabled', 'true');
        send.style.opacity = '0.5';
        return;
      }
      const lines = Array.from(basket.values()).map(line => format('message_line', { quantity: line.quantity, name: line.name, cup: text[line.cup === 0 ? 'cup_ice' : 'cup_no_ice'], amount: line.quantity * 15 }));
      const message = [text.message_intro, ...lines, format('order_total', { amount }), text[method.value + '_message']].join('\n');
      send.href = 'https://wa.me/971565467327?text=' + encodeURIComponent(message);
      send.removeAttribute('aria-disabled');
      send.style.opacity = '1';
    };
    const renderBasket = () => {
      list.replaceChildren();
      if (!basket.size) status.textContent = text.basket_empty;
      for (const [key, line] of basket) {
        const row = document.createElement('div');
        row.className = 'candy-pop-basket-line';
        row.style.cssText = 'padding:16px 0;border-bottom:1px solid #ddd;display:grid;gap:10px';
        const title = document.createElement('p');
        title.textContent = line.name + ' — ' + text[line.cup === 0 ? 'cup_ice' : 'cup_no_ice'];
        title.style.cssText = 'margin:0;font-weight:600';
        const quantity = makeQuantity('candy-pop-line-' + key, format('basket_quantity', { name: line.name, cup: text[line.cup === 0 ? 'cup_ice' : 'cup_no_ice'] }), line.quantity);
        quantity.addEventListener('change', () => {
          const next = Number(quantity.value);
          if (drinkCount(line.id) - line.quantity + next > 20) {
            quantity.value = String(line.quantity);
            status.textContent = text.max_quantity;
            return;
          }
          line.quantity = next;
          status.textContent = text.basket_updated;
          renderBasket();
        });
        const lineTotal = document.createElement('p');
        lineTotal.textContent = format('order_total', { amount: line.quantity * 15 });
        lineTotal.style.margin = '0';
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = text.remove;
        remove.setAttribute('aria-label', format('remove_item', { name: title.textContent }));
        remove.style.cssText = 'min-height:44px;padding:8px 12px;border:1px solid #61149c;border-radius:10px;background:#fff;color:#61149c;font:inherit';
        remove.addEventListener('click', () => {
          basket.delete(key);
          status.textContent = '';
          renderBasket();
        });
        row.append(title, quantity, lineTotal, remove);
        list.append(row);
      }
      updateMessage();
    };
    cards.forEach((card, index) => {
      const name = card.querySelector('h3').textContent.trim();
      const wrap = document.createElement('div');
      wrap.className = 'candy-pop-quantity';
      wrap.style.cssText = 'margin:16px 0;display:grid;gap:8px';
      const label = document.createElement('label');
      label.htmlFor = 'candy-pop-quantity-' + index;
      label.textContent = text.quantity;
      label.style.fontWeight = '600';
      const quantity = makeQuantity(label.htmlFor, format('quantity_for', { name }));
      const subtotal = document.createElement('p');
      subtotal.setAttribute('aria-live', 'polite');
      const updateSubtotal = () => { subtotal.textContent = format('order_total', { amount: Number(quantity.value) * 15 }); };
      quantity.addEventListener('change', updateSubtotal);
      wrap.append(label, quantity, subtotal);
      const options = card.querySelector('.candy-pop-cup-options');
      options.before(wrap);
      const intro = options.previousElementSibling.previousElementSibling;
      if (intro && intro.tagName === 'P') intro.textContent = text.choose_cup;
      Array.from(options.querySelectorAll('.candy-pop-cup-order')).forEach((link, cup) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'candy-pop-add-drink';
        button.style.cssText = link.style.cssText + ';border:0;font:inherit;cursor:pointer';
        button.textContent = text[cup === 0 ? 'add_ice' : 'add_no_ice'];
        button.setAttribute('aria-label', button.textContent + ' — ' + name);
        button.addEventListener('click', () => {
          const count = Number(quantity.value);
          if (drinkCount(index) + count > 20) {
            status.textContent = text.max_quantity;
            status.scrollIntoView({ block: 'nearest', behavior: 'auto' });
            return;
          }
          const key = index + '-' + cup;
          const line = basket.get(key);
          if (line) line.quantity += count;
          else basket.set(key, { id: index, name, cup, quantity: count });
          status.textContent = format('added', { quantity: count, name });
          renderBasket();
        });
        link.replaceWith(button);
      });
      updateSubtotal();
    });
    method.addEventListener('change', updateMessage);
    renderBasket();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();